<cx-spinner class="overlay" *ngIf="isUpdating$ | async"></cx-spinner>
<h1 class="gonvarri-login-title">{{ 'loginForm.title' | cxTranslate }}</h1>
<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <p *cxFeature="'a11yRequiredAsterisks'" class="form-legend">
    {{ 'formLegend.required' | cxTranslate }}
  </p>
  <label>
    <span class="label-content">
      {{ 'loginForm.emailAddress.label' | cxTranslate }}
      <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
    </span>
    <input
      required="true"
      type="text"
      class="form-control"
      formControlName="userId"
      placeholder="{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}"
    />

    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      [translationParams]="{
        label: 'loginForm.emailAddress.label' | cxTranslate,
      }"
      [control]="form.get('userId')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('userId')"
    ></cx-form-errors>
  </label>

  <label>
    <span class="label-content">
      {{ 'loginForm.password.label' | cxTranslate }}
      <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
    </span>
    <input
      required="true"
      type="password"
      class="form-control"
      placeholder="{{ 'loginForm.password.placeholder' | cxTranslate }}"
      formControlName="password"
      [attr.aria-label]="'loginForm.password.placeholder' | cxTranslate"
      cxPasswordVisibilitySwitch
    />

    <cx-form-errors
      *cxFeature="'formErrorsDescriptiveMessages'"
      [translationParams]="{
        label: 'loginForm.password.label' | cxTranslate,
      }"
      [control]="form.get('password')"
    ></cx-form-errors>

    <cx-form-errors
      *cxFeature="'!formErrorsDescriptiveMessages'"
      [control]="form.get('password')"
    ></cx-form-errors>
  </label>

  <button
    type="submit"
    class="btn btn-block btn-primary"
    [disabled]="form.disabled"
  >
    {{ 'loginForm.signIn' | cxTranslate }}
  </button>

  <a [routerLink]="{ cxRoute: 'forgotPassword' } | cxUrl" class="btn-link">
    {{ 'loginForm.forgotPassword' | cxTranslate }}
  </a>
</form>

<ng-template #requiredAsterisk>
  <abbr
    *cxFeature="'a11yRequiredAsterisks'"
    class="text-decoration-none"
    aria-hidden="true"
    title="{{ 'common.required' | cxTranslate }}"
    >*</abbr
  >
</ng-template>
